import {
  faCheck,
  faChevronLeft,
  faChevronRight,
  faHeadphones,
  faLightbulb,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { B2Button } from "@hdb/biome-2";
import * as _ from "lodash";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { Form } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { safeAtob } from "../../../../../../shared/helpers/enode-decode-string";
import {
  getAssetByCode,
  getAssetsByGateway,
  getLightGroups,
  getSelectedGroupsAssets,
  getTriggeringZones,
  postGroupAssets,
  removeGroupAssets,
  setSelectedGroupsAssets,
  updateGroupAssets,
} from "../../../../../../store/slices/asset.slice";

const LightingGroupComponent = forwardRef(
  ({ selectedGroup }: any, ref) => {
    const dispatch = useDispatch();
    const params: any = useParams();
    const id = params.id ? safeAtob(params.id) : null;

    const [newGroupName, setNewGroupName] = useState("" as any);
    const [error, setError] = useState({
      isEmpty: false,
      isCharacterExceeds50: false,
    });

    const [PageNumber, setPageNumber] = useState(0);
    const [PageSize, setPageSize] = useState(0);

    const assetDetails = useSelector((state: any) => {
      return state.asset.assetDetails;
    });

    /*     const isLoadingAssetDetails = useSelector((state: any) => {
      return state.asset.isLoadingAssetDetails;
    }); */

    const searchedAssets = useSelector((state: any) => {
      return state.asset.searchedAssetsByGateway;
    });

    const isLoadingSearchedAssets = useSelector((state: any) => {
      return state.asset.isLoadingsearchedAssetsByGateway;
    });

    const selectedGroupsAssets = useSelector((state: any) => {
      return state.asset.selectedGroupsAssets;
    });

    const [selectedAssets, setSelectedAssets] = useState([] as any);

    const [selectedAssetCodeFromGroup, setSelectedAssetCodeFromGroup] =
      useState("" as any);

    const onChangeGroup = (e: any) => {
      if (e.target.value.length) {
        const isEmpty = false;
        let characterCountNotOk = false;

        if (e.target.value.length <= 50) {
          characterCountNotOk = false;
        } else {
          characterCountNotOk = true;
        }

        setError({
          isEmpty: isEmpty,
          isCharacterExceeds50: characterCountNotOk,
        });
      }

      setNewGroupName(e.target.value);
    };

    const onSearchAsset = (e: any) => {
      if (e.key === "Enter") {
        dispatch(
          getAssetsByGateway({
            searchText: e.target.value,
            gatewayCode: id,
            PageNumber,
            PageSize,
          })
        );
      }
    };

    const onChange = (e: any) => {
      if (e.target.value.length % 3 === 0) {
        dispatch(
          getAssetsByGateway({
            PageNumber: 0,
            PageSize: 0,
            searchText: e.target.value,
            gatewayCode: id,
          })
        );
      }
    };

    useEffect(() => {
      dispatch(
        getAssetsByGateway({
          PageNumber: 0,
          PageSize: 0,
          searchText: "",
          gatewayCode: id,
        })
      );
    }, []);

    const addAssets = () => {
      if (!selectedAssets?.length) return;
      const copySelectedGroupsAssets = _.cloneDeep(selectedGroupsAssets);

      for (let asset of selectedAssets) {
        if (
          !copySelectedGroupsAssets.find(
            (x: any) => x.assetCode === asset.assetCode
          )
        ) {
          copySelectedGroupsAssets.push({
            assetCode: asset.assetCode,
            sensorDisplayName: asset.sensorDisplayName,
            zoneTypeId: 1,
          });
        }
      }
      dispatch(setSelectedGroupsAssets(copySelectedGroupsAssets));
    };

    const removeAssets = () => {
      if (!selectedAssetCodeFromGroup) return;
      let copySelectedGroupsAssets = [...selectedGroupsAssets];

      if (
        copySelectedGroupsAssets.find(
          (asset) => asset.assetCode === selectedAssetCodeFromGroup
        )
      ) {
        copySelectedGroupsAssets = copySelectedGroupsAssets.filter(
          (asset) => asset.assetCode !== selectedAssetCodeFromGroup
        );
      }
      dispatch(setSelectedGroupsAssets(copySelectedGroupsAssets));
    };

    const onZoneTypeToggle = (
      assetCode: any,
      isRemove: boolean = false,
      isZoneTypeId: boolean = true
    ) => {
      if (selectedGroupsAssets?.length) {
        let copySelectedGroupsAssets = _.cloneDeep(selectedGroupsAssets);
        if (
          copySelectedGroupsAssets.find(
            (asset: any) => asset.assetCode === assetCode
          )
        ) {
          const targetAsset = copySelectedGroupsAssets.find(
            (asset: any) => asset.assetCode === assetCode
          );
          if (isZoneTypeId) {
            targetAsset.zoneTypeId = targetAsset.zoneTypeId === 1 ? 2 : 1;
          }

          if (targetAsset?.isRemove && isRemove) {
            targetAsset.isRemove = !targetAsset?.isRemove;
          } else if (isRemove) {
            targetAsset.isRemove = true;
          }
        }

        dispatch(setSelectedGroupsAssets(copySelectedGroupsAssets));
      }
    };

    useEffect(() => {
      if (!id || Object.keys(assetDetails).length) return;
      dispatch(getAssetByCode({ id }));
      dispatch(getTriggeringZones({ id }));
    }, [id]);

    useImperativeHandle(ref, () => {
      return {
        onSubmit: () => {
          if (!selectedGroup) {
            let isEmpty = false;
            let characterCountNotOk = false;

            if (!newGroupName || newGroupName?.length > 50) {
              if (!newGroupName) {
                isEmpty = true;
              }

              if (newGroupName?.length > 50) {
                characterCountNotOk = true;
              }

              setError({
                isCharacterExceeds50: characterCountNotOk,
                isEmpty: isEmpty,
              });

              return "error";
            }
          }

          const removedAssetCodes = {
            strs: selectedGroupsAssets
              .filter((asset: any) => asset.isRemove === true)
              .map((asset: any) => asset.assetCode),
          };

          // delete the item from the selectedGroupsAssets where isRemove is true
          const updatedSelectedGroupsAssets = selectedGroupsAssets.filter(
            (asset: any) => asset.isRemove !== true
          );

          if (updatedSelectedGroupsAssets?.length <= 0) {
            toast.warning("Group should have minimum 1 asset", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              draggable: true,
              pauseOnHover: true,
            });

            return "error";
          }

          const data: any = {
            gatewayCode: id,
            gatewayGroupDetails: updatedSelectedGroupsAssets,
          };

          if (selectedGroup) {
            data["id"] = selectedGroup.id;
            data["groupName"] = newGroupName || selectedGroup?.groupName;
          } else {
            data["groupName"] = newGroupName;
          }

          if (selectedGroup && Object.keys(selectedGroup).length) {
            dispatch(updateGroupAssets({ body: data }))
              .then((r: any) => {
                if (removedAssetCodes?.strs?.length) {
                  return dispatch(
                    removeGroupAssets({ body: removedAssetCodes })
                  );
                }
              })
              .then((r: any) => {
                dispatch(
                  getLightGroups({
                    gatewayCode: id,
                    PageNumber: 1,
                    PageSize: 10,
                  })
                );
              });
          } else {
            dispatch(postGroupAssets({ body: data })).then((r: any) => {
              dispatch(
                getLightGroups({
                  gatewayCode: id,
                  PageNumber: 1,
                  PageSize: 10,
                })
              );
            });
          }
        },
      };
    });

    useEffect(() => {
      setSelectedGroupsAssets([]);
    }, []);

    useEffect(() => {
      if (selectedGroup && Object.keys(selectedGroup).length) {
        dispatch(
          getSelectedGroupsAssets({
            groupId: selectedGroup.id,
          })
        );
      }

    }, [selectedGroup]);

    return (
      <div>
        {/* <div className="asset-details">
        <InfoTileContainer
          header="Asset Details"
          isLoading={isLoadingAssetDetails}
          count={2}
        >
          <InfoTileComponent
            title="Asset ID"
            value={assetDetails.assetId}
            valueWidth={3}
          />
          <InfoTileComponent
            title="Asset Type"
            value={assetDetails.assetType}
          />
        </InfoTileContainer>

        <InfoTileContainer
          header="Location Details"
          isLoading={isLoadingAssetDetails}
          count={4}
        >
          <InfoTileComponent
            title="Town Council"
            value={assetDetails.townCouncil}
          />
          <InfoTileComponent title="Site" value={assetDetails.site} />
          <InfoTileComponent title="Block" value={assetDetails.block} />
          <InfoTileComponent title="Street" value={assetDetails?.street} />
        </InfoTileContainer>
      </div> */}
        <div className="">
          <div className="bg-card">
            {/* <div style={{ fontSize: "19px", fontWeight: "700" }}>
            Manage Light Groups
          </div> */}
            <div className="">
              <div className="flex">
                {/* left section */}
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <Form.Group>
                      <Form.Label>Group</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Group"
                        onChange={(e) => onChangeGroup(e)}
                        value={
                          newGroupName
                          || selectedGroup?.groupName
                          || ""
                        }
                      />
                      {error?.isEmpty && (
                        <div className="error-message">
                          Group name is required
                        </div>
                      )}
                      {error?.isCharacterExceeds50 && (
                        <div className="error-message">
                          Group name should not be more than 50 characters
                        </div>
                      )}
                    </Form.Group>
                  </div>

                  <div
                    className="mt-3"
                    style={{
                      backgroundColor: "#ebebeb",
                      height: "500px",
                      overflow: "auto",
                      borderRadius: "7px",
                    }}
                  >
                    <div className="mt-3">
                      {selectedGroupsAssets?.map((asset: any, index: number) => (
                        <button
                          key={index + 0}
                          type="button"
                          onClick={() => {
                            setSelectedAssetCodeFromGroup(asset.assetCode);
                            setSelectedAssets([]);
                          }}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            fontSize: "15px",
                            fontWeight: "600",
                            padding: "0.5rem 1rem",
                            color:
                              selectedAssetCodeFromGroup === asset.assetCode
                                ? "#1976D2"
                                : "#212529",
                            cursor: "pointer",
                            backgroundColor:
                              selectedAssetCodeFromGroup === asset.assetCode
                                ? "1976D2"
                                : "transparent",
                            border: "none",
                            width: "100%",
                            textAlign: "left",
                          }}
                        >
                          <div>
                            {asset?.isRemove ? (
                              <del>{asset.sensorDisplayName}</del>
                            ) : (
                              asset.sensorDisplayName
                            )}
                          </div>
                          <div
                            style={{ marginLeft: "10px" }}
                          // onClick={(e) => {
                          //   e.stopPropagation();
                          //   onZoneTypeToggle(asset.assetCode);
                          // }}
                          >
                            {asset.zoneTypeId === 1 ? (
                              <div className="d-flex align-items-center justify-content-center">
                                <FontAwesomeIcon
                                  icon={faHeadphones}
                                  className="fs-7 ms-2"
                                  title="Trigger Node"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    onZoneTypeToggle(asset.assetCode, false);
                                  }}
                                />
                                <FontAwesomeIcon
                                  icon={asset?.isRemove ? faCheck : faXmark}
                                  className="fs-5 ms-2 text-danger"
                                  title="Remove"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    onZoneTypeToggle(
                                      asset.assetCode,
                                      true,
                                      false
                                    );
                                  }}
                                />
                              </div>
                            ) : (
                              <div className="d-flex align-items-center justify-content-center">
                                <FontAwesomeIcon
                                  icon={faLightbulb}
                                  className="fs-7 ms-2"
                                  title="Light Node"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    onZoneTypeToggle(asset.assetCode, false);
                                  }}
                                />
                                <FontAwesomeIcon
                                  icon={asset?.isRemove ? faCheck : faXmark}
                                  className="fs-5 ms-2 text-danger"
                                  title="Remove"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    onZoneTypeToggle(
                                      asset.assetCode,
                                      true,
                                      false
                                    );
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        </button>
                      ))}
                    </div>
                  </div>
                </div>

                {/* middle section */}
                <div className="flex flex-col items-center justify-center ms-5 me-5">
                  <B2Button
                    variant="primary"
                    className="d-flex justify-center items-center"
                    onClick={() => addAssets()}
                  >
                    <div className="d-flex me-2">
                      <FontAwesomeIcon icon={faChevronLeft} className="fs-7" />
                      <FontAwesomeIcon icon={faChevronLeft} className="fs-7" />
                    </div>
                    {/* <div>Add</div> */}
                  </B2Button>

                  {/* Remove */}
                  {!selectedGroup && (
                    <B2Button
                      variant="primary"
                      className="mt-3 d-flex justify-center items-center"
                      onClick={() => removeAssets()}
                    >
                      <div className="d-flex ms-2">
                        <FontAwesomeIcon
                          icon={faChevronRight}
                          className="fs-7"
                        />
                        <FontAwesomeIcon
                          icon={faChevronRight}
                          className="fs-7"
                        />
                      </div>
                    </B2Button>
                  )}
                </div>

                {/* right section */}
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div className="d-flex justify-center items-center w-full">
                    <div className="w-full">
                      <Form.Group>
                        <Form.Label>Search Asset</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Search Asset"
                          onKeyUp={(e) => onSearchAsset(e)}
                          onChange={(e) => onChange(e)}
                        />
                      </Form.Group>
                    </div>
                    {isLoadingSearchedAssets ? (
                      <Spinner
                        className="mt-4 ms-2"
                        style={{ color: "#1976D2" }}
                        animation="border"
                        role="status"
                        size="sm"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    ) : null}
                  </div>

                  <div
                    className="mt-3"
                    style={{
                      backgroundColor: "#ebebeb",
                      height: "500px",
                      overflow: "auto",
                      borderRadius: "7px",
                    }}
                  >
                    <div className="mt-3">
                      {searchedAssets.map((asset: any, index: number) => (
                        <button
                          key={index + 0}
                          type="button"
                          onClick={() => {
                            const copiedSelectedAssets = [...selectedAssets];
                            if (
                              !copiedSelectedAssets.find(
                                (x: any) => x.assetCode === asset.assetCode
                              )
                            ) {
                              copiedSelectedAssets.push(asset);
                            }
                            setSelectedAssets(copiedSelectedAssets);
                            setSelectedAssetCodeFromGroup("");
                          }}
                          style={{
                            fontSize: "15px",
                            fontWeight: "600",
                            padding: "0.5rem 1rem",
                            marginBottom: "2px",
                            color: selectedAssets.find(
                              (x: any) => x.assetCode === asset.assetCode
                            )
                              ? "#1976D2"
                              : "#212529",
                            cursor: "pointer",
                            backgroundColor: selectedAssets.find(
                              (x: any) => x.assetCode === asset.assetCode
                            )
                              ? "1976D2"
                              : "transparent",
                            border: "none",
                            width: "100%",
                            textAlign: "left",
                          }}
                        >
                          {asset.sensorDisplayName}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default LightingGroupComponent;
